import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate } from "react-router";
import { useAuth } from "./provider";
export function ProtectedRoute({ children, loginPath = "/auth", setupPath = "/setup/mfa", }) {
    const { bootstrapped, isAuthenticated, requiresSetup } = useAuth();
    // Wait until the bootstrap /refresh probe has resolved so we don't
    // briefly redirect an already-authenticated user to the login page.
    if (!bootstrapped) {
        return null;
    }
    if (!isAuthenticated) {
        return _jsx(Navigate, { to: loginPath, replace: true });
    }
    if (requiresSetup) {
        return _jsx(Navigate, { to: setupPath, replace: true });
    }
    return _jsx(_Fragment, { children: children });
}
//# sourceMappingURL=protected-route.js.map